import React from "react";
import Footer from "./Components/Footer";
import NavigationBar from "./NavigationBar/NavigationBar";
import NeoDropdown from "./Dropdown/NeoDropdown";
import ErrorBox from "./Components/ErrorBox";
import axios from "axios";
import { BASE_URL, CLEAR_BASE_URL } from "./Constants";
import LoadingSpinner from "./LoadingSpinner";
import NeoButton from "./Button/NeoButton";
import ConfirmationView from "./ConfirmationView";
import NeoCheckbox from "./Checkbox/NeoCheckbox";
import Cookies from "js-cookie";

class CreateOffer extends React.Component {
    inter = null;

    state = {
        company_name: "",
        street: "",
        zip: "",
        city: "",
        hasCompanyGroup: false,

        rate: 0,
        insurance_fee: 0,
        insurance_available: null,
        objectName: "",
        objectNumber: "",
        objectManufacturer: "",
        objectPrice: "",
        leasingDuration: 36,
        accessories: "",
        accessoriesPrice: "",
        insurance: "none",

        profile: {},

        errorsMaxSonde: [],
        errorMessageMaxSonde: null,

        errors: [],
        errorMessage: null,
        isSent: false,
        isLoading: true,
        noUserFound: false,
        isSending: false,
        privacy: 0,

        leadingObject: "",
        leasingCondition: "new",
        leasingCalculationType: "rate",
        special_rent_payment: "",
        provision: 0,

        alternative_delievery_address: false,
        saved: false,

        calcLoading: false,
        showRate: false,
        customerLoading: false,
        showCustomer: false,
        restwert: "",
        bj: "",
        ok: "",

        rates: [],
        selected_insurance: "",
        id:
            typeof this.props.match.params.id !== "undefined"
                ? this.props.match.params.id
                : null,

        all_objects: [],
        all_conditions: [],
        all_insurens: [],
        object_art: [],
        note: "",
        reverse_calc: 0,
        selectedRates: [],
        salutation: "allgemein",
        convertMode: false,
        bucket: null,

        showConvertRateModal: false,
        selectedConvertRate: null,
        showOfferSavedModal: false,
        isPrintingOffer: false,
    };

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleNoteChange = this.handleNoteChange.bind(this);
        this.searchUser = this.searchUser.bind(this);
        this.sendOffer = this.sendOffer.bind(this);
        this.createDraftOffer = this.createDraftOffer.bind(this);
        this.loadUserInfo = this.loadUserInfo.bind(this);
        this.calculateLeasingRate = this.calculateLeasingRate.bind(this);
        this.recalculateLeasingRate = this.recalculateLeasingRate.bind(this);
        this.onRadioChange = this.onRadioChange.bind(this);
        this.onRadioDatenschutzChange = this.onRadioDatenschutzChange.bind(this);
        this.handleDeliveryAddress = this.handleDeliveryAddress.bind(this);
        this.handleChangeFilter = this.handleChangeFilter.bind(this);
        this.handleChangeFilterRestwert = this.handleChangeFilterRestwert.bind(this);
        this.handleChangeFilterObject = this.handleChangeFilterObject.bind(this);
        this.handleChangeFilterProvision = this.handleChangeFilterProvision.bind(this);
        this.handleChangeFilterArt = this.handleChangeFilterArt.bind(this);
        this.handleChangeFilterInsurance = this.handleChangeFilterInsurance.bind(this);
        this.handleChangeData = this.handleChangeData.bind(this);
        this.toggleRateSelection = this.toggleRateSelection.bind(this);
        this.saveOfferAndReturn = this.saveOfferAndReturn.bind(this);
        this.convertDraftToApplication = this.convertDraftToApplication.bind(this);
        this.loadDraftOffer = this.loadDraftOffer.bind(this);
        this.updateDraftOffer = this.updateDraftOffer.bind(this);
        this.confirmConvertToApplication = this.confirmConvertToApplication.bind(this);
        this.closeConvertRateModal = this.closeConvertRateModal.bind(this);
        this.renderConvertRateModal = this.renderConvertRateModal.bind(this);
        this.closeOfferSavedModal = this.closeOfferSavedModal.bind(this);
        this.printSavedOffer = this.printSavedOffer.bind(this);
        this.renderOfferSavedModal = this.renderOfferSavedModal.bind(this);
        this.activateDraftModeWithRate = this.activateDraftModeWithRate.bind(this);
    }

    componentDidMount() {
        const searchParams = new URLSearchParams(this.props.location.search);
        const convertMode = searchParams.get("convert") === "1";
        const requestedBucket = searchParams.get("bucket");

        this.setState(
            {
                convertMode,
                bucket:
                    requestedBucket === "offer"
                        ? "offer"
                        : requestedBucket === "draft"
                            ? "draft"
                            : null,
            },
            () => {
                if (this.state.id == null) {
                    this.createDraftOffer(this.state.bucket ?? "offer");
                } else {
                    this.loadDraftOffer();
                }
            }
        );

        this.inter = setInterval(() => {
            if (!this.state.id) {
                return;
            }

            this.setState({ saved: true });
            this.updateDraftOffer();
        }, 10000);
    }

    componentWillUnmount() {
        if (this.inter != null) {
            clearInterval(this.inter);
        }
    }

    getCurrentBucket() {
        return this.state.bucket === "draft" ? "draft" : "offer";
    }

    ErrorsViewMaxSonder() {
        const { errorsMaxSonde } = this.state;
        const { errorMessageMaxSonde } = this.state;

        return errorsMaxSonde !== null ? (
            <ErrorBox errorMessage={errorMessageMaxSonde} errors={errorsMaxSonde} />
        ) : null;
    }

    ErrorsView() {
        const { errors } = this.state;
        const { errorMessage } = this.state;

        return errorMessage !== null ? (
            <ErrorBox errorMessage={errorMessage} errors={errors} />
        ) : null;
    }

    loadUserInfo() {}

    sendOffer() {
        const { id } = this.props.match.params;

        this.setState({ isSending: true });

        let branchID = Cookies.get("CurrentStoreID");

        axios
            .post(
                BASE_URL +
                (this.state.useCompanyGroup
                    ? "/vendor/offer-create/company"
                    : "/vendor/offer-create"),
                {
                    object_name: this.state.objectName,
                    object_price: this.objectPrice(),
                    object_number: this.state.objectNumber,
                    object_manufacturer: this.state.objectManufacturer,
                    equipment: this.state.accessories,
                    equipment_price: this.accessoriesPrice(),
                    leasing_duration: this.state.leasingDuration,
                    insurance_fee: this.state.insurance_fee,
                    object_art: this.state.art,
                    restwert: this.state.restwert,
                    total_price: this.totalPrice(),
                    user: { ...this.state.profile, salutation: this.state.salutation },
                    rate: this.state.rate,
                    user_uuid: id,
                    insurance: this.state.selected_insurance,
                    branch_id: branchID,
                    id: this.state.id,
                    note: this.state.note,
                }
            )
            .then(() => {
                this.setState({
                    isSending: false,
                    isSent: true,
                    bucket: "offer",
                    showConvertRateModal: false,
                    selectedConvertRate: null,
                });

                if (this.inter != null) {
                    clearInterval(this.inter);
                }

                let klo = this.props;
                let inernid = this.state.id;

                setTimeout(function () {
                    klo.history.push("/vendor/offers/" + inernid + "/upload");
                }, 1400);
            })
            .catch((error) => {
                if (error.response) {
                    this.setState({
                        isSending: false,
                        errors: error.response.data.errors,
                        errorMessage: error.response.data.message,
                    });
                } else {
                    this.setState({
                        isSending: false,
                        errorMessage: "Der Antrag konnte nicht erstellt werden.",
                        errors: [],
                    });
                }
            });
    }

    onRadioChange(event) {
        this.setState({
            insurance: event.target.value,
            rate: 0,
            insurance_fee: 0,
            insurance_available: null,
        });
    }

    onRadioDatenschutzChange(event) {
        this.setState({
            privacy: event.target.value,
        });
    }

    updateDraftOffer(callback = null) {
        const bucket = this.getCurrentBucket();

        axios
            .post(BASE_URL + "/vendor/offers/draft/update", {
                bucket_type: bucket,
                id: this.state.id,
                leadingData: this.state.leadingObject,
                objectName: this.state.objectName,
                objectPrice: this.totalPrice(),
                leadingObject: this.state.leadingObject,
                leasingCondition: this.state.leasingCondition,
                leasingCalculationType: this.state.leasingCalculationType,
                special_rent_payment: this.state.special_rent_payment,
                provision: this.state.provision,
                rate: this.state.rate,
                restwert: this.state.restwert,
                bj: this.state.bj,
                user: this.state.profile,
                leasing_duration: this.state.leasingDuration,
                selected_insurance: this.state.selected_insurance,
                selected_rates: this.state.selectedRates,
                note: this.state.note,
                profile: { ...this.state.profile, salutation: this.state.salutation },
                isLoading: false,
                object_art: this.state.art,
            })
            .then((result) => {
                const backendBucket = String(
                    result?.data?.offer?.bucket_type ??
                    result?.data?.bucket_type ??
                    bucket
                )
                    .toLowerCase()
                    .trim();

                this.setState(
                    {
                        bucket: backendBucket === "draft" ? "draft" : "offer",
                        errorMessage: null,
                        errors: [],
                    },
                    () => {
                        setTimeout(() => {
                            this.setState({ saved: false });
                        }, 1000);

                        if (typeof callback === "function") {
                            callback();
                        }
                    }
                );
            })
            .catch((error) => {
                if (error.response) {
                    this.setState({
                        errors: error.response.data.errors,
                        errorMessage: error.response.data.message,
                        isLoading: false,
                    });
                }

                setTimeout(() => {
                    this.setState({ saved: false });
                }, 1000);
            });
    }

    loadDraftOffer() {
        axios
            .get(BASE_URL + "/vendor/offer/" + this.state.id)
            .then((result) => {
                const data = result.data.offer;

                const all_objects = [];
                (result.data.objects || []).map((item) =>
                    all_objects.push({ value: item.id, name: item.name })
                );

                const object_art = [];
                const object_art_string = ["VA", "VT", "Mietkauf", "Miete"];
                (result.data.object_art || []).map((item) =>
                    object_art.push({
                        value: item.object_id,
                        index: object_art_string[item.object_id - 1]?.toLowerCase(),
                        name: object_art_string[item.object_id - 1],
                    })
                );

                const selectedRates =
                    Array.isArray(data.selected_rates) && data.selected_rates.length > 0
                        ? data.selected_rates
                        : data.leasing_rate != null && data.leasing_duration != null
                            ? [
                                {
                                    name: new Intl.NumberFormat("de-DE", {
                                        style: "currency",
                                        currency: "EUR",
                                    }).format(Math.round(data.leasing_rate * 100) / 100),
                                    value: data.leasing_rate,
                                    sub: data.leasing_duration + " Monate",
                                    duration: data.leasing_duration,
                                    insurance_fee: data.insurance_fee ?? 0,
                                    insurance_available: Boolean(data.insurance_fee),
                                },
                            ]
                            : [];

                const requestedBucket = new URLSearchParams(
                    this.props.location.search
                ).get("bucket");

                const backendStatus = String(data.status ?? "").toLowerCase().trim();
                const backendBucket = String(
                    data.bucket_type ?? data.record_type ?? data.type ?? ""
                )
                    .toLowerCase()
                    .trim();

                let bucket = "offer";

                if (backendStatus === "completed") {
                    bucket = "offer";
                } else if (requestedBucket === "offer" || requestedBucket === "draft") {
                    bucket = requestedBucket;
                } else if (["draft", "entwurf"].includes(backendBucket)) {
                    bucket = "draft";
                } else if (["offer", "angebot", "quote"].includes(backendBucket)) {
                    bucket = "offer";
                }

                const normalizedRates =
                    bucket === "draft" && selectedRates.length > 0
                        ? [selectedRates[0]]
                        : selectedRates;

                console.log(JSON.stringify(data))
                this.setState({
                    all_objects: all_objects,
                    object_art: object_art,
                    objectName: data.object_name ?? "",
                    leadingObject: data.object_type ?? "",
                    leasingCondition: data.object_state ?? "new",
                    bj: data.bj ?? "",
                    leasing_calculation_type: data.leasing_calculation_type ?? "",
                    leasingCalculationType: data.leasingCalculationType ?? "rate",
                    objectPrice:
                        data.object_price == null
                            ? data.leasing_rate == null
                                ? ""
                                : data.leasing_rate
                            : data.object_price,
                    special_rent_payment: data.special_rent_payment ?? "",
                    provision: data.provision ?? 0,
                    insurance: data.insurance ?? "none",
                    profile: data.profile ?? {},
                    reverse_calc: data.reverse_calc ?? 0,
                    selectedRates: normalizedRates,
                    rate: normalizedRates[0]?.value ?? data.leasing_rate ?? 0,
                    leasingDuration:
                        normalizedRates[0]?.duration ?? data.leasing_duration ?? 36,
                    selected_insurance: data.selected_insurance ?? data.insurance ?? "",
                    note: data.note ?? "",
                    salutation:
                        data.profile?.salutation ?? data.salutation ?? "allgemein",
                    bucket,
                    art: data.object_art ?? data.art ?? data.art ?? data.leasing_calculation_type ?? "",
                    showCustomer: Boolean(
                        (data.profile && Object.keys(data.profile).length > 0) ||
                        (data.note && data.note.length > 0)
                    ),
                    isLoading: false,
                    rates: normalizedRates.length > 0 ? normalizedRates : selectedRates,
                    showRate: selectedRates.length > 0,
                });
            })
            .catch((error) => {
                if (error.response) {
                    this.setState({
                        errors: error.response.data.errors,
                        errorMessage: error.response.data.message,
                        isLoading: false,
                    });
                } else {
                    this.setState({
                        errorMessage: "Der Datensatz konnte nicht geladen werden.",
                        errors: [],
                        isLoading: false,
                    });
                }
            });
    }

    createDraftOffer(bucketOverride = null) {
        let branchID = Cookies.get("CurrentStoreID");
        const bucket = bucketOverride === "draft" ? "draft" : "offer";

        axios
            .post(BASE_URL + "/vendor/offers/draft", {
                branch_id: branchID,
                bucket_type: bucket,
            })
            .then((result) => {
                const data = result.data;

                const all_objects = [];
                (result.data.objects || []).map((item) =>
                    all_objects.push({ value: item.id, name: item.name })
                );

                const object_art = [];
                const object_art_string = ["VA", "VT", "Mietkauf", "Miete"];
                (result.data.object_art || []).map((item) =>
                    object_art.push({
                        value: item.object_id,
                        index: object_art_string[item.object_id - 1]?.toLowerCase(),
                        name: object_art_string[item.object_id - 1],
                    })
                );

                this.setState({
                    bucket,
                    reverse_calc: result.data.offer?.reverse_calc ?? 0,
                    isLoading: false,
                    id: data.offer.id,
                    all_objects: all_objects,
                    object_art: object_art,
                });
            })
            .catch((error) => {
                if (error.response) {
                    this.setState({
                        isLoading: false,
                        errors: error.response.data.errors,
                        errorMessage: error.response.data.message,
                    });
                } else {
                    this.setState({
                        isLoading: false,
                        errorMessage: "Der Entwurf konnte nicht angelegt werden.",
                        errors: [],
                    });
                }
            });
    }

    calculateLeasingRate(duration) {
        axios
            .post(BASE_URL + "/vendor/calc-rate-new", {
                total_price: this.totalPrice(),
                insurance: this.state.insurance,
                obj: this.state.leadingObject,
                provision: this.state.provision,
                special_rent_payment: this.state.special_rent_payment,
                art: this.state.art,
                restwert: this.state.restwert,
                type: this.state.leasingCalculationType,
            })
            .then((result) => {
                let ratesData = [];
                (result.data.rates || []).map((item) =>
                    ratesData.push({
                        name: new Intl.NumberFormat("de-DE", {
                            style: "currency",
                            currency: "EUR",
                        }).format(Math.round(item.rate * 100) / 100),
                        value: item.rate,
                        sub: item.laufzeit + " Monate",
                        duration: item.laufzeit,
                        insurance_fee: 0,
                        insurance_available: false,
                    })
                );

                let insurance = [];
                (result.data.insurance || []).map((item) =>
                    insurance.push({
                        name: item.name,
                        value: item.id,
                        sub: item.price.toLocaleString() + " €",
                    })
                );

                this.setState({ rates: ratesData, all_insurens: insurance });
            })
            .catch((error) => {
                if (error.response) {
                    this.setState({
                        errors: error.response.data.errors,
                        errorMessage: error.response.data.message,
                    });
                }
            });
    }

    recalculateLeasingRate() {
        this.setState({ rates: [], calcLoading: true, selectedRates: [] });

        this.calculateLeasingRate(12);

        setTimeout(() => {
            this.setState({ calcLoading: false, showRate: true });
        }, 2000);
    }

    handleDeliveryAddress() {
        if (this.state.alternative_delievery_address) {
            this.setState({
                delievery_city: "",
                delievery_zip: "",
                delievery_street: "",
                delievery_name: "",
                alternative_delievery_address:
                    !this.state.alternative_delievery_address,
            });
        } else {
            this.setState({
                alternative_delievery_address:
                    !this.state.alternative_delievery_address,
            });
        }
    }

    searchUser() {
        axios
            .get(
                BASE_URL + "/vendor/offers/find?email=" + this.state.profile.contact_email
            )
            .then((result) => {
                const profile = result.data;

                if (typeof result.data.birthday !== "undefined") {
                    profile.gf_birthdate = profile.birthday;
                    this.setState({ profile: profile });
                }
            });
    }

    handleNoteChange(event) {
        this.setState({
            note: event.target.value,
        });
    }

    handleChangeFilterObject(event) {
        this.setState({
            leadingObject: event.value,
            showRate: false,
            showCustomer: false,
            errors: [],
        });
    }

    handleChangeFilterRestwert(event) {
        this.setState({
            restwert: event.value,
            errors: [],
        });
    }

    handleChangeFilterInsurance(event) {
        this.setState({
            selected_insurance: event.value,
            insurance_fee: event.sub,
            errors: [],
        });
    }

    handleChangeFilterProvision(event) {
        this.setState({
            provision: event.value,
            errors: [],
        });
    }

    handleChangeFilterArt(event) {
        this.setState({
            art: event.index,
            restwert: "",
            showRate: false,
            showCustomer: false,
            errors: [],
            selectedRates: [],
            rate: 0,
            leasingDuration: 36,
        });
    }

    handleChangeFilter(event) {
        this.setState({
            rate: event.value,
            leasingDuration: event.duration,
            errors: [],
        });
    }

    handleChange(event) {
        const value = event.target.value;
        const profile = { ...this.state.profile };
        profile[event.target.name] = value;

        this.setState({
            profile: profile,
            errors: [],
        });

        if (event.target.name === "objectPrice") {
            this.setState({ rate: 0, insurance_fee: 0, insurance_available: null });
        }
    }

    handleChangeData(event) {
        let value = event.target.value;
        let errorMessageMaxSonde = null;

        if (event.target.name === "special_rent_payment") {
            let calcMaxRange = (this.state.objectPrice / 100) * 30;

            if (calcMaxRange < value) {
                value = calcMaxRange.toFixed(2).replace(".", ",");
                errorMessageMaxSonde = "Max. 30% vom Kaufpreis möglich";
            }
        }

        this.setState({
            [event.target.name]: value,
            showRate: false,
            showCustomer: false,
            errors: [],
            errorMessageMaxSonde: errorMessageMaxSonde,
            selectedRates: [],
            rate: 0,
            leasingDuration: 36,
        });

        if (event.target.name === "objectPrice") {
            this.setState({ rate: 0, insurance_fee: 0, insurance_available: null });
        }
    }

    handleChangeDuration = (duration) => {
        this.setState({ leasingDuration: duration.value });
        this.calculateLeasingRate(duration.value);
    };

    toggleRateSelection(rateOption) {
        if (this.getCurrentBucket() === "draft") {
            this.setState({
                selectedRates: [rateOption],
                rate: rateOption.value,
                leasingDuration: rateOption.duration,
                insurance_fee: rateOption.insurance_fee ?? 0,
                errors: [],
                errorMessage: null,
            });
            return;
        }

        const selectedRates = [...this.state.selectedRates];
        const index = selectedRates.findIndex(
            (item) =>
                item.duration === rateOption.duration && item.value === rateOption.value
        );

        if (index >= 0) {
            selectedRates.splice(index, 1);
        } else {
            if (selectedRates.length >= 3) {
                this.setState({
                    errorMessage:
                        "Es können maximal 3 Laufzeit-/Ratenoptionen ausgewählt werden.",
                    errors: [],
                });
                return;
            }

            selectedRates.push(rateOption);
        }

        const primaryRate = selectedRates[0] || null;

        this.setState({
            selectedRates,
            rate: primaryRate ? primaryRate.value : 0,
            leasingDuration: primaryRate ? primaryRate.duration : 36,
            insurance_fee: primaryRate ? primaryRate.insurance_fee : 0,
            errors: [],
            errorMessage: null,
        });
    }

    saveOfferAndReturn() {
        this.setState({ saved: true });

        this.updateDraftOffer(() => {
            if (this.getCurrentBucket() === "offer") {
                this.setState({
                    showOfferSavedModal: true,
                    saved: false,
                });
                return;
            }

            this.props.history.push("/vendor");
        });
    }

    activateDraftModeWithRate(selectedRate) {
        const normalizedRate = selectedRate || this.state.selectedRates[0] || null;

        if (!normalizedRate) {
            this.setState({
                errorMessage: "Bitte wählen Sie eine Leasingrate für den Antrag aus.",
                errors: [],
            });
            return;
        }

        this.setState(
            {
                showConvertRateModal: false,
                bucket: "draft",
                selectedRates: [normalizedRate],
                rates: [normalizedRate],
                selectedConvertRate: normalizedRate,
                rate: normalizedRate.value,
                leasingDuration: normalizedRate.duration,
                insurance_fee: normalizedRate.insurance_fee ?? 0,
                showRate: true,
                showCustomer: true,
                errorMessage: null,
                errors: [],
            },
            () => {
                this.updateDraftOffer(() => {
                    this.props.history.replace(
                        "/vendor/offers/" + this.state.id + "/update?bucket=draft"
                    );
                });
            }
        );
    }

    convertDraftToApplication() {
        if (this.state.selectedRates.length === 0) {
            this.setState({
                errorMessage: "Bitte wählen Sie mindestens eine Rate/Laufzeit aus.",
                errors: [],
            });
            return;
        }

        if (this.state.selectedRates.length === 1) {
            this.activateDraftModeWithRate(this.state.selectedRates[0]);
            return;
        }

        this.setState({
            showConvertRateModal: true,
            selectedConvertRate: this.state.selectedRates[0] ?? null,
            errorMessage: null,
            errors: [],
        });
    }

    closeConvertRateModal() {
        this.setState({
            showConvertRateModal: false,
            selectedConvertRate: null,
        });
    }

    closeOfferSavedModal() {
        this.setState({ showOfferSavedModal: false });
        this.props.history.push("/vendor");
    }

    printSavedOffer() {
        this.setState({ isPrintingOffer: true });

        const printUrl = BASE_URL + "/vendor/offer/" + this.state.id + "/print";
        window.open(printUrl, "_blank");

        setTimeout(() => {
            this.setState({
                isPrintingOffer: false,
                showOfferSavedModal: false,
            });
            this.props.history.push("/vendor");
        }, 400);
    }

    renderOfferSavedModal() {
        if (!this.state.showOfferSavedModal) {
            return null;
        }

        return (
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: "rgba(0,0,0,0.45)",
                    zIndex: 9999,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 20,
                }}
            >
                <div
                    className="neo-card"
                    style={{
                        width: "100%",
                        maxWidth: 520,
                        padding: 24,
                        borderRadius: 14,
                        background: "#fff",
                    }}
                >
                    <p
                        className="neo-smallTitle"
                        style={{ marginTop: 0, marginBottom: 12, textAlign: "left" }}
                    >
                        Angebot wurde gespeichert
                    </p>

                    <p className="neo-callout" style={{ marginTop: 0, marginBottom: 20 }}>
                        Das Angebot wurde erfolgreich gespeichert.
                    </p>

                    <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                        <NeoButton
                            title="Angebot drucken"
                            showLoadingState={this.state.isPrintingOffer}
                            onClick={this.printSavedOffer}
                        />
                        <NeoButton
                            title="Schließen"
                            isSecondary={true}
                            onClick={this.closeOfferSavedModal}
                        />
                    </div>
                </div>
            </div>
        );
    }

    confirmConvertToApplication() {
        const selectedRate = this.state.selectedConvertRate;

        if (!selectedRate) {
            this.setState({
                errorMessage: "Bitte wählen Sie eine Leasingrate für den Antrag aus.",
                errors: [],
            });
            return;
        }

        this.activateDraftModeWithRate(selectedRate);
    }

    renderConvertRateModal() {
        if (!this.state.showConvertRateModal) {
            return null;
        }

        return (
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: "rgba(0,0,0,0.45)",
                    zIndex: 9999,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 20,
                }}
            >
                <div
                    className="neo-card"
                    style={{
                        width: "100%",
                        maxWidth: 700,
                        maxHeight: "85vh",
                        overflowY: "auto",
                        padding: 20,
                        borderRadius: 14,
                        background: "#fff",
                    }}
                >
                    <p
                        className="neo-smallTitle"
                        style={{ marginTop: 0, marginBottom: 12, textAlign: "left" }}
                    >
                        Rate für Antrag auswählen
                    </p>

                    <p className="neo-callout" style={{ marginTop: 0 }}>
                        Es wurden mehrere Laufzeiten / Leasingraten ausgewählt. Bitte wählen
                        Sie aus, welche Rate für den Antrag verwendet werden soll.
                    </p>

                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns:
                                window.innerWidth < 800 ? "1fr" : "1fr 1fr",
                            gap: 12,
                            marginTop: 10,
                        }}
                    >
                        {this.state.selectedRates.map((rateOption) => {
                            const isSelected =
                                this.state.selectedConvertRate &&
                                this.state.selectedConvertRate.duration ===
                                rateOption.duration &&
                                this.state.selectedConvertRate.value === rateOption.value;

                            return (
                                <div
                                    key={
                                        "convert-rate-" +
                                        rateOption.duration +
                                        "-" +
                                        rateOption.value
                                    }
                                    className="neo-card-cell"
                                    onClick={() =>
                                        this.setState({ selectedConvertRate: rateOption })
                                    }
                                    style={{
                                        cursor: "pointer",
                                        border: isSelected
                                            ? "2px solid #5d84b2"
                                            : "1px solid #e6ebf2",
                                        borderRadius: 10,
                                        background: isSelected ? "#f4f8fc" : "#fff",
                                    }}
                                >
                                    <div style={{ width: "100%", textAlign: "center" }}>
                                        <div className="neo-smallTitle" style={{ margin: 0 }}>
                                            {rateOption.name}
                                        </div>
                                        <div
                                            className="neo-callout"
                                            style={{ marginBottom: 0 }}
                                        >
                                            {rateOption.sub}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    <div
                        style={{ display: "flex", gap: 10, marginTop: 20, flexWrap: "wrap" }}
                    >
                        <NeoButton
                            title="Ausgewählte Rate verwenden"
                            onClick={this.confirmConvertToApplication}
                        />
                        <NeoButton
                            title="Abbrechen"
                            isSecondary={true}
                            onClick={this.closeConvertRateModal}
                        />
                    </div>
                </div>
            </div>
        );
    }

    rateOptionCard(rateOption) {
        const isSelected = this.state.selectedRates.some(
            (item) =>
                item.duration === rateOption.duration && item.value === rateOption.value
        );

        const isPrimary =
            this.state.selectedRates.length > 0 &&
            this.state.selectedRates[0].duration === rateOption.duration &&
            this.state.selectedRates[0].value === rateOption.value;

        return (
            <div
                key={rateOption.duration + "-" + rateOption.value}
                onClick={() => this.toggleRateSelection(rateOption)}
                className="neo-card-cell"
                style={{
                    cursor: "pointer",
                    marginBottom: 12,
                    border: isSelected ? "2px solid #5d84b2" : "1px solid #e6ebf2",
                    borderRadius: 10,
                    background: isSelected ? "#f4f8fc" : "#fff",
                }}
            >
                <div style={{ width: "100%", textAlign: "center" }}>
                    <div className="neo-smallTitle" style={{ margin: 0 }}>
                        {rateOption.name}
                    </div>
                    <div className="neo-callout" style={{ marginBottom: 0 }}>
                        {rateOption.sub}
                    </div>
                    {isPrimary && this.getCurrentBucket() === "offer" ? (
                        <div className="neo-callout" style={{ marginBottom: 0 }}>
                            Auswahl für spätere Antragserstellung
                        </div>
                    ) : null}
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="neo-app">
                <NavigationBar />

                <div className="neo-content">
                    <p className="neo-bar-title">
                        {this.getCurrentBucket() === "draft"
                            ? this.state.id
                                ? "Entwurf bearbeiten"
                                : "Neuer Antrag"
                            : this.state.id
                                ? "Angebot bearbeiten"
                                : "Neues Angebot"}
                    </p>

                    {this.state.isLoading ? (
                        this.LoadingView()
                    ) : this.state.isSent ? (
                        <ConfirmationView
                            text="Der Antrag wurde erfolgreich erstellt. Sie werden gleich zum Dokumentenupload geleitet."
                            icon="confirmation.png"
                        />
                    ) : (
                        this.OfferForm()
                    )}
                </div>

                {this.renderConvertRateModal()}
                {this.renderOfferSavedModal()}

                <Footer />
            </div>
        );
    }

    addCustomer() {
        this.setState({ customerLoading: true, showCustomer: true });

        setTimeout(() => {
            this.setState({ customerLoading: false });
        }, 2000);
    }

    LoadingView() {
        return <LoadingSpinner title="Laden..." />;
    }

    OfferForm() {
        return (
            <div>
                <div className="neo-card">
                    <p
                        className="neo-smallTitle"
                        style={{ marginTop: 0, marginBottom: 15, textAlign: "left" }}
                    >
                        Leasingobjekt
                    </p>

                    <NeoDropdown
                        title="Bezeichnung"
                        items={this.state.all_objects}
                        value={this.state.leadingObject}
                        onChangeValue={this.handleChangeFilterObject}
                        trailingString=""
                    />
                </div>

                <div className="neo-card">
                    <p
                        className="neo-smallTitle"
                        style={{ marginTop: 0, marginBottom: 15, textAlign: "left" }}
                    >
                        Zustand
                    </p>

                    <div
                        className="neo-card-cell"
                        onClick={() =>
                            this.setState({
                                showRate: false,
                                showCustomer: false,
                                leasingCondition: "new",
                            })
                        }
                    >
                        <input
                            type="radio"
                            id="leasing_condition_new"
                            name="leasingCondition"
                            value="new"
                            checked={this.state.leasingCondition === "new"}
                            onChange={this.onRadioChange}
                        />
                        <label htmlFor="none" className="neo-text">
                            <span>Neu</span>
                        </label>
                    </div>

                    <div
                        className="neo-card-cell"
                        onClick={() =>
                            this.setState({
                                showRate: false,
                                showCustomer: false,
                                leasingCondition: "second_hand",
                            })
                        }
                    >
                        <input
                            type="radio"
                            id="leasing_condition_second_hand"
                            name="leasingCondition"
                            value="second_hand"
                            checked={this.state.leasingCondition === "second_hand"}
                            onChange={this.onRadioChange}
                        />
                        <label htmlFor="business_and_private" className="neo-text">
                            <span>Gebraucht</span>
                        </label>
                    </div>
                </div>

                {this.state.leasingCondition === "second_hand" ? (
                    <input
                        type="text"
                        placeholder={"Baujahr"}
                        name="bj"
                        value={this.state.bj}
                        onChange={this.handleChangeData}
                    />
                ) : null}

                <div className="neo-card">
                    <p
                        className="neo-smallTitle"
                        style={{ marginTop: 0, marginBottom: 15, textAlign: "left" }}
                    >
                        Berechnungsart
                    </p>

                    <div
                        className="neo-card-cell"
                        onClick={() =>
                            this.setState({
                                showRate: false,
                                showCustomer: false,
                                objectPrice: "",
                                leasingCalculationType: "rate",
                            })
                        }
                    >
                        <input
                            type="radio"
                            id="rate"
                            name="leasingCalculationType"
                            value="rate"
                            checked={this.state.leasingCalculationType === "rate"}
                            onChange={this.onRadioChange}
                        />
                        <label htmlFor="rate" className="neo-text">
                            <span>Rate berechnen</span>
                        </label>
                    </div>

                    {this.state.reverse_calc === 1 ? (
                        <div
                            className="neo-card-cell"
                            onClick={() =>
                                this.setState({
                                    showRate: false,
                                    showCustomer: false,
                                    objectPrice: "",
                                    leasingCalculationType: "reverse_calc",
                                })
                            }
                        >
                            <input
                                type="radio"
                                id="reverse_calc"
                                name="leasingCalculationType"
                                value="reverse_calc"
                                checked={
                                    this.state.leasingCalculationType === "reverse_calc"
                                }
                                onChange={this.onRadioChange}
                            />
                            <label htmlFor="reverse_calc" className="neo-text">
                                <span>Rückwärtsrechner</span>
                            </label>
                        </div>
                    ) : null}
                </div>

                <div className="neo-card">
                    <p
                        className="neo-smallTitle"
                        style={{ marginTop: 0, marginBottom: 15, textAlign: "left" }}
                    >
                        Vertragsart
                    </p>


                    <NeoDropdown
                        title="Bezeichnung"
                        items={this.state.object_art}
                        value={this.state.art}
                        onChangeValue={this.handleChangeFilterArt}
                        trailingString=""
                    />
                </div>

                {this.state.art === "vt" ? (
                    <div className="neo-card" style={{ paddingBottom: 1 }}>
                        <p
                            className="neo-smallTitle"
                            style={{ marginTop: 0, marginBottom: 15, textAlign: "left" }}
                        >
                            Restwert des Objektes
                        </p>

                        <NeoDropdown
                            title="Restwert des Objektes"
                            items={[
                                { name: "5", value: 5 },
                                { name: "10", value: 10 },
                                { name: "15", value: 15 },
                                { name: "20", value: 20 },
                                { name: "25", value: 25 },
                                { name: "30", value: 30 },
                            ]}
                            value={this.state.restwert}
                            allowdropdown={true}
                            onChangeValue={this.handleChangeFilterRestwert}
                            trailingString="%"
                        />
                    </div>
                ) : null}

                <input
                    type="text"
                    placeholder={
                        this.state.leasingCalculationType === "reverse_calc"
                            ? "Wunschrate netto"
                            : "Kaufpreis netto"
                    }
                    name="objectPrice"
                    value={this.state.objectPrice}
                    onChange={this.handleChangeData}
                />

                <input
                    type="text"
                    placeholder="Sonderzahlung (optional)"
                    name="special_rent_payment"
                    value={this.state.special_rent_payment}
                    onChange={this.handleChangeData}
                />

                {this.state.errorMessageMaxSonde != null
                    ? this.ErrorsViewMaxSonder()
                    : null}

                <input
                    type="text"
                    placeholder="Bezeichnung"
                    name="objectName"
                    value={this.state.objectName}
                    onChange={this.handleChangeData}
                />

                <div className="neo-card" style={{ paddingBottom: 1 }}>
                    <p
                        className="neo-smallTitle"
                        style={{ marginTop: 0, marginBottom: 15, textAlign: "left" }}
                    >
                        Händlerprovision
                    </p>

                    <NeoDropdown
                        title="Bezeichnung"
                        items={[
                            { name: "1", value: 1 },
                            { name: "2", value: 2 },
                            { name: "3", value: 3 },
                            { name: "4", value: 4 },
                            { name: "5", value: 5 },
                            { name: "keine", value: 0 },
                        ]}
                        value={this.state.provision}
                        allowdropdown={true}
                        onChangeValue={this.handleChangeFilterProvision}
                        trailingString="%"
                    />
                </div>

                <div className="neo-spacer20" />
                <div className="neo-spacer20" />

                <NeoButton title="Berechnen" onClick={this.recalculateLeasingRate} />

                {this.ErrorsView()}

                {this.state.calcLoading ? (
                    this.LoadingView()
                ) : this.state.showRate ? (
                    <>
                        <div className="neo-card">
                            <p
                                className="neo-smallTitle"
                                style={{ marginTop: 0, marginBottom: 15, textAlign: "left" }}
                            >
                                Rate & Laufzeit wählen
                            </p>

                            {this.getCurrentBucket() === "offer" ? (
                                <p className="neo-callout" style={{ marginTop: 0 }}>
                                    Mehrfachauswahl möglich, max. 3 Alternativen. Die erste
                                    Auswahl wird für die spätere Antragserstellung verwendet.
                                </p>
                            ) : null}

                            <div
                                style={{
                                    display: "grid",
                                    gridTemplateColumns:
                                        window.innerWidth < 800 ? "1fr" : "1fr 1fr",
                                    gap: 12,
                                }}
                            >
                                {this.state.rates.map((rateOption) =>
                                    this.rateOptionCard(rateOption)
                                )}
                            </div>
                        </div>

                        {this.state.all_insurens.length === 0 ? null : (
                            <div className="neo-card">
                                <p
                                    className="neo-smallTitle"
                                    style={{ marginTop: 0, marginBottom: 15, textAlign: "left" }}
                                >
                                    Versicherung
                                </p>

                                <NeoDropdown
                                    title="Bezeichnung"
                                    items={this.state.all_insurens}
                                    value={this.state.selected_insurance}
                                    onChangeValue={this.handleChangeFilterInsurance}
                                    trailingString=""
                                />
                            </div>
                        )}

                        <NeoButton
                            title="Weiter"
                            disabled={this.state.selectedRates.length < 1}
                            onClick={() => this.addCustomer()}
                        />
                    </>
                ) : null}

                {this.state.customerLoading ? (
                    this.LoadingView()
                ) : this.state.showCustomer ? (
                    <>
                        <p
                            className="neo-smallTitle"
                            style={{ marginTop: 0, marginBottom: 15, textAlign: "left" }}
                        >
                            Kundendaten
                        </p>

                        <div className="neo-card">
                            <p
                                className="neo-smallTitle"
                                style={{ marginTop: 0, marginBottom: 15, textAlign: "left" }}
                            >
                                Anrede
                            </p>

                            <div
                                style={{
                                    display: "grid",
                                    gridTemplateColumns:
                                        window.innerWidth < 800 ? "1fr" : "1fr 1fr 1fr",
                                    gap: 10,
                                }}
                            >
                                {[
                                    { value: "herr", label: "Herr" },
                                    { value: "frau", label: "Frau" },
                                    { value: "allgemein", label: "Allgemein" },
                                ].map((salutationItem) => (
                                    <div
                                        key={salutationItem.value}
                                        className="neo-card-cell"
                                        onClick={() =>
                                            this.setState({
                                                salutation: salutationItem.value,
                                            })
                                        }
                                        style={{
                                            border:
                                                this.state.salutation === salutationItem.value
                                                    ? "2px solid #5d84b2"
                                                    : "1px solid #e6ebf2",
                                            borderRadius: 10,
                                            cursor: "pointer",
                                        }}
                                    >
                                        <label className="neo-text">
                                            <span>{salutationItem.label}</span>
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {this.getCurrentBucket() === "draft" ? (
                        <input
                            type="text"
                            placeholder="E-Mail"
                            name="contact_email"
                            value={this.state.profile.contact_email ?? ""}
                            onChange={this.handleChange}
                            onBlur={() => this.searchUser()}
                        />) : null}


                        <input
                            type="text"
                            placeholder="Firma"
                            name="company_name"
                            value={this.state.profile.company_name ?? ""}
                            onChange={this.handleChange}
                        />

                        <input
                            type="text"
                            placeholder="Name"
                            name="contact_name"
                            value={this.state.profile.contact_name ?? ""}
                            onChange={this.handleChange}
                        />

                        <input
                            type="text"
                            placeholder="Straße"
                            name="street"
                            value={this.state.profile.street ?? ""}
                            onChange={this.handleChange}
                        />

                        <input
                            type="text"
                            placeholder="PLZ"
                            name="zip"
                            value={this.state.profile.zip ?? ""}
                            onChange={this.handleChange}
                        />

                        <input
                            type="text"
                            placeholder="Ort"
                            name="city"
                            value={this.state.profile.city ?? ""}
                            onChange={this.handleChange}
                        />

                        {this.getCurrentBucket() === "draft" ? (
                            <>
                                <div className="neo-spacer20" />

                                <p
                                    className="neo-smallTitle"
                                    style={{ marginTop: 0, marginBottom: 15, textAlign: "left" }}
                                >
                                    Angaben zum Geschäftsführer
                                </p>

                                <input
                                    type="text"
                                    placeholder="Vorname"
                                    name="firstname"
                                    value={this.state.profile.firstname ?? ""}
                                    onChange={this.handleChange}
                                />

                                <input
                                    type="text"
                                    placeholder="Nachname"
                                    name="lastname"
                                    value={this.state.profile.lastname ?? ""}
                                    onChange={this.handleChange}
                                />

                                <input
                                    type="text"
                                    placeholder="Straße"
                                    name="gf_street"
                                    value={this.state.profile.gf_street ?? ""}
                                    onChange={this.handleChange}
                                />

                                <input
                                    type="text"
                                    placeholder="PLZ"
                                    name="gf_zip"
                                    value={this.state.profile.gf_zip ?? ""}
                                    onChange={this.handleChange}
                                />

                                <input
                                    type="text"
                                    placeholder="Ort"
                                    name="gf_city"
                                    value={this.state.profile.gf_city ?? ""}
                                    onChange={this.handleChange}
                                />

                                <div>
                                    <p
                                        className="neo-smallTitle"
                                        style={{ textAlign: "left", paddingBottom: 10 }}
                                    >
                                        Geburtstag
                                    </p>
                                    <input
                                        type="date"
                                        placeholder="Geburtstag"
                                        name="gf_birthdate"
                                        value={this.state.profile.gf_birthdate ?? ""}
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </>
                        ) : null}

                        {this.getCurrentBucket() === "draft" ? (
                            <>
                                <NeoCheckbox
                                    style={{ marginTop: 10 }}
                                    showTermsButton={true}
                                    name="alternative_delievery_address"
                                    label="Abweichender  Lieferant"
                                    value={this.state.alternative_delievery_address}
                                    onChange={this.handleDeliveryAddress}
                                />

                                <div className="neo-spacer20" />

                                {this.state.alternative_delievery_address ? (
                                    <>
                                        <input
                                            type="text"
                                            placeholder="Firmenname"
                                            name="delievery_name"
                                            value={this.state.profile.delievery_name ?? ""}
                                            onChange={this.handleChange}
                                        />

                                        <input
                                            type="text"
                                            placeholder="Straße"
                                            name="delievery_street"
                                            value={this.state.profile.delievery_street ?? ""}
                                            onChange={this.handleChange}
                                        />

                                        <input
                                            type="text"
                                            placeholder="PLZ"
                                            name="delievery_zip"
                                            value={this.state.profile.delievery_zip ?? ""}
                                            onChange={this.handleChange}
                                        />

                                        <input
                                            type="text"
                                            placeholder="Ort"
                                            name="delievery_city"
                                            value={this.state.profile.delievery_city ?? ""}
                                            onChange={this.handleChange}
                                        />

                                        <div className="neo-spacer20" />
                                    </>
                                ) : null}

                                <p
                                    className="neo-smallTitle"
                                    style={{ marginTop: 0, marginBottom: 15, textAlign: "left" }}
                                >
                                    Bankdaten
                                </p>

                                <input
                                    type="text"
                                    placeholder="IBAN (optional)"
                                    name="iban"
                                    value={this.state.profile.iban ?? ""}
                                    onChange={this.handleChange}
                                />

                                <input
                                    type="text"
                                    placeholder="BIC (optional)"
                                    name="bic"
                                    value={this.state.profile.bic ?? ""}
                                    onChange={this.handleChange}
                                />
                            </>
                        ) : null}

                        <div className="neo-spacer20" />
                        <div className="neo-spacer20" />

                        <textarea
                            type="text"
                            placeholder="Notizen (optional)"
                            name="note"
                            value={this.state.note}
                            onChange={this.handleNoteChange}
                        >
                            {this.state.note}
                        </textarea>

                        <div className="neo-card">
                            <div
                                className="neo-card-cell"
                                onClick={() => this.setState({ ok: "done" })}
                            >
                                <input
                                    type="radio"
                                    id="ok_new"
                                    name="ok"
                                    value="done"
                                    checked={this.state.ok === "done"}
                                    onChange={this.onRadioDatenschutzChange}
                                />
                                <label htmlFor="none" className="neo-text">
                                    <span>
                                        Hiermit bestätige ich, dass mir die Einwilligung zur
                                        Verarbeitung personenbezogener Daten einschließlich
                                        Bonitätsprüfung und Übermittlung einer Ausweisskopie
                                        vorliegt.
                                    </span>
                                </label>
                                <a
                                    className="termsButton"
                                    href={CLEAR_BASE_URL + "/Einwilligung.pdf"}
                                    target={"_blank"}
                                    rel="noreferrer"
                                >
                                    Ansehen
                                </a>
                            </div>
                        </div>

                        <NeoButton
                            title={
                                this.getCurrentBucket() === "draft"
                                    ? "Antrag speichern"
                                    : "Angebot speichern"
                            }
                            onClick={this.saveOfferAndReturn}
                            disabled={false}
                        />

                        {this.getCurrentBucket() === "offer" ? (
                            <NeoButton
                                title="In Antrag wandeln"
                                showLoadingState={this.state.isSending}
                                onClick={this.convertDraftToApplication}
                                disabled={
                                    this.state.ok !== "done" ||
                                    this.state.selectedRates.length < 1
                                }
                            />
                        ) : (
                            <NeoButton
                                title="Antrag senden & Dokumente hochladen"
                                showLoadingState={this.state.isSending}
                                onClick={this.sendOffer}
                                disabled={
                                    this.state.ok !== "done" ||
                                    this.state.selectedRates.length !== 1
                                }
                            />
                        )}

                        {this.ErrorsView()}
                    </>
                ) : null}

                <div className="neo-spacer20" />

                {this.state.saved ? (
                    <div style={{ position: "fixed", right: 10, bottom: 10 }}>
                        <NeoButton
                            style={{ width: "auto", paddingLeft: 10, paddingRight: 10 }}
                            title="speichern"
                        />
                    </div>
                ) : null}
            </div>
        );
    }

    totalPrice() {
        let objectPrice = this.state.objectPrice ? String(this.state.objectPrice) : "0";
        objectPrice = objectPrice.replace(".", "");
        objectPrice = objectPrice.replace(",", ".");

        return parseFloat(objectPrice);
    }

    objectPrice() {
        let objectPrice = this.state.objectPrice ? String(this.state.objectPrice) : "0";
        objectPrice = objectPrice.replace(".", "");
        objectPrice = objectPrice.replace(",", ".");

        return parseFloat(objectPrice);
    }

    accessoriesPrice() {
        let accessoriesPrice = this.state.accessoriesPrice
            ? String(this.state.accessoriesPrice)
            : "0";
        accessoriesPrice = accessoriesPrice.replace(".", "");
        accessoriesPrice = accessoriesPrice.replace(",", ".");

        return parseFloat(accessoriesPrice);
    }
}

export default CreateOffer;